
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"25","height":"25","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_22814_192732)"}},[_c('path',{attrs:{"d":"M20.314 6.71h-7.5l-2.5-2.5h-6.25c-1.035 0-1.875.84-1.875 1.876v13.75c0 1.035.84 1.875 1.875 1.875h16.25c1.036 0 1.875-.84 1.875-1.875V8.586c0-1.035-.84-1.875-1.875-1.875zm-5 8.403h-2.187v2.188c-.035.554-.418.972-.938.972a.9.9 0 01-.902-.902v-2.258H9.03a.898.898 0 01-.902-.902.9.9 0 01.902-.903h2.188V11.05a.985.985 0 01.973-.902c.519 0 .902.42.902.902v2.223h2.187c.555 0 .973.418.973.938s-.418.902-.937.902z","fill":"#000"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_22814_192732"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(2.19 2.96)","d":"M0 0h20v20H0z"}})])])])
          )
        }
      }
    